import React from 'react';
import { ShareButton } from '../styles/share.style';

/**
 * Share Component
 * @returns {XML} Share component
 */
const Share = () => (
  <ShareButton className="share-link" data-target="share" aria-label="Open Share Options">
    <span className="share-link__text" data-event="Share" data-label="share">
      { 'Share' }
    </span>
    <div className="share-link__icons">
      <div className="share-link__icons-wrapper">
        <h3 className="share-link__mobile-header mobile-only">Share</h3>
        <a
          className="share-link__icon share-link__icon--facebook"
          target="_blank"
          href="https://www.facebook.com/sharer.php?u=https://www.xfl.com"
          title="Facebook Page"
          rel="noopener noreferrer"
        >
          { 'Facebook' }
        </a>
        <a
          className="share-link__icon share-link__icon--twitter"
          target="_blank"
          href={
            'https://twitter.com/intent/tweet?url='
            + 'text=I%20can%E2%80%99t%20wait%20for%20the%20XFL%20to%20come%20back!!%20%23XFL2020'
          }
          title="Twitter Page"
          rel="noopener noreferrer"
        >
          { 'Twitter' }
        </a>
        <a
          className="share-link__icon share-link__icon--mail"
          href={
            // eslint-disable-next-line
            'mailto:?subject=Get%20your%20game%20face%20on.%20The%20XFL%20is%20back.&amp;body=Prepare%20to%20be%20amazed.%20The%20XFL%20makes%20its%20triumphant%20return%20in%202020.%20Learn%20more%20about%20how%20we%E2%80%99re%20revolutionizing%20the%20game%20forever.%20%23XFL2020%20xfl.com'
          }
          title="Email"
        >
          { 'Email' }
        </a>
      </div>
      <a
        className="share-link__close-button mobile-only"
        href="#share"
        title="Share"
        aria-label="Close Overlay"
        rel="noopener noreferrer"
      >
        <svg
          className="circle-svg"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="58"
          height="58"
        >
          <circle className="circle-svg__circle" r="19" cx="50%" cy="50%" strokeDasharray="1, 6" />
          <circle
            className="circle-svg__circle circle-svg__circle--big"
            r="27"
            cx="50%"
            cy="50%"
            strokeDasharray="1, 3"
          />
        </svg>
      </a>
    </div>
  </ShareButton>
);

export default Share;



// WEBPACK FOOTER //
// ./src/components/share/components/share.js